import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import LogoutModal from "../Modals/LogoutModal";
import { MdDashboard } from "react-icons/md";

function Sidebar() {
     // modal
   const [show, setShow] = useState(false);

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
   useEffect(() => {
    if (document.querySelectorAll(".sidebar_links.active").length > 0) {
      var pagelinkofset =
        document.querySelectorAll(".sidebar_links.active")[0].offsetTop;
      document
        .getElementById("scrollbar_sidebar_id")
        .scrollTo(0, pagelinkofset - 100);
        console.log(pagelinkofset,"pagelinkofset");
    }
  },[]);
  return (
    <>
      <div className="sidebar d-flex flex-column justify-content-between align-items-start">
        <div className="w-100">
        <div className="sidebar_logo_holder px-4 py-3">
            <img src={require('../assets/images/logo.png')} className="img-fluid main_logo" />
        </div>
        <ul className="pt-4" id="scrollbar_sidebar_id">
            <li className="mb-3">
                <NavLink to='/dashboard' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid.svg').default} className="img-fluid sidebar_linkImg" />
                   
                    <p className="sidebar_link_hint">Dashboard</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/tokenList' className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Tokens</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/userList' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid3.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Users</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/categorylist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/user.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Category</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/faqList' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid5.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Faq List</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/subscriberlist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid6.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Subscriber Lists</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/subscriberadd' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid7.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Newsletter</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/cmslist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid8.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">CMS Management</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/purchasedlist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid9.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Sales Report Management</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/reportlist' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid10.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Report Management</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/nfttag' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid11.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">NFT Share Tag Management</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/settings' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid12.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Social Links</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/editserviceFee' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid13.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Service Fee Management</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/user' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid14.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">User Profile</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/plannedUser' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/prime.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Planned User</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/subscriptionadd' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/plan.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Subscription Plans</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/Domains' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Campaign</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/SBT' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">SBT Tokens</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/Collection' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/grid2.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Bulk Collection</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/RevenueDetails' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/user.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Revenue</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/categorylistSBT' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/gridlast1.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">SBT Category</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/categorylistFractional' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/gridlast1.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Fractional Category</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/editserviceFraction' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/user.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Service Fee Fractions</p>
                </NavLink>
            </li>

            <li className="mb-3">
                <NavLink to='/ListCustomtoken' className="sidebar_links rounded-end-5 d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                    <img src={require('../assets/images/gridlast.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">TokenList</p>
                </NavLink>
            </li>
        </ul>
        </div>

        <div className="w-100">
        <li className="mb-3" onClick={handleShow}>
                <div className="sidebar_links rounded-end-5  d-flex gap-3 justify-content-start align-items-center p-2 ps-4">
                <img src={require('../assets/images/logout.svg').default} className="img-fluid sidebar_linkImg" />
                    <p className="sidebar_link_hint">Logout</p>
                </div>
            </li>
            </div>
            
      </div>

      {/* modals */}
    <LogoutModal show={show} handleClose={handleClose} />
      {/* end of modals */}
    </>
  );
}

export default Sidebar;